const mutations = {
    SET_TEMPLATES(state, payload) {
        state.templates = payload;
    },

    SET_TEMPLATE(state, payload) {
        state.template = payload;
    },

    SET_FETCH_TEMPLATES_LOADING(state, payload) {
        state.fetchTemplatesLoading = payload;
    },

    SET_FETCH_TEMPLATE_LOADING(state, payload) {
        state.fetchTemplateLoading = payload;
    },

    SET_CREATE_TEMPLATE_LOADING(state, payload) {
        state.createTemplateLoading = payload;
    },

    SET_UPDATE_TEMPLATE_LOADING(state, payload) {
        state.updateTemplateLoading = payload;
    },

    SET_DELETE_TEMPLATE_LOADING(state, payload) {
        state.deleteTemplateLoading = payload;
    },
}

export default mutations;